var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"thankyou-container"},[_c('h1',[_vm._v("Vielen Dank für deine Teilnahme!")]),_c('router-link',{staticClass:"highscore",attrs:{"to":"/menu","tag":"div"}},[_vm._v("zur Startseite")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }